// PhoneInput Component - Simple version
import React from 'react';
import { Input } from './input';
import { Label } from './label';
import { Phone } from 'lucide-react';

// Simple phone input without international codes for now
export function formatPhoneForDisplay(number) {
    if (!number) return '';
    const cleaned = String(number).replace(/\D/g, '');
    return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
}

export function parseInternationalPhone(fullPhone) {
    if (!fullPhone) return { countryCode: '+241', localNumber: '' };
    const str = String(fullPhone);
    if (str.startsWith('+241')) {
        return { countryCode: '+241', localNumber: str.slice(4) };
    }
    return { countryCode: '+241', localNumber: str };
}

export function validatePhone(localNumber) {
    const cleaned = String(localNumber || '').replace(/\D/g, '');
    if (!cleaned) return { valid: true, message: '' };
    if (cleaned.length !== 8) {
        return { valid: false, message: 'Le numéro doit contenir 8 chiffres' };
    }
    return { valid: true, message: '' };
}

export function PhoneInput(props) {
    const { 
        value = '', 
        onChange, 
        label = 'Téléphone', 
        disabled = false,
        required = false,
        error = null 
    } = props;

    const [localNumber, setLocalNumber] = React.useState('');
    const [validationMsg, setValidationMsg] = React.useState('');

    React.useEffect(() => {
        const parsed = parseInternationalPhone(value);
        setLocalNumber(parsed.localNumber || '');
    }, [value]);

    function handleChange(e) {
        let input = e.target.value.replace(/\D/g, '');
        if (input.length > 8) {
            input = input.slice(0, 8);
        }
        setLocalNumber(input);
        
        const validation = validatePhone(input);
        setValidationMsg(validation.valid ? '' : validation.message);
        
        if (onChange) {
            const fullNumber = input ? '+241' + input : '';
            onChange(fullNumber);
        }
    }

    const displayError = error || validationMsg;

    return (
        <div className="space-y-2">
            {label && (
                <Label className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    {label}
                    {required && <span className="text-red-500">*</span>}
                </Label>
            )}
            <div className="flex gap-2">
                <div className="flex items-center px-3 bg-gray-100 dark:bg-gray-800 rounded-md text-sm">
                    🇬🇦 +241
                </div>
                <Input
                    type="tel"
                    value={formatPhoneForDisplay(localNumber)}
                    onChange={handleChange}
                    placeholder="XX XX XX XX"
                    disabled={disabled}
                    className={'flex-1 font-mono ' + (displayError ? 'border-red-500' : '')}
                    maxLength={12}
                />
            </div>
            {displayError && (
                <p className="text-xs text-red-500">{displayError}</p>
            )}
        </div>
    );
}

export default PhoneInput;
